import { styledOptions } from "../../../utils/styled-options/styled-options.es.js";
import { styled } from "@mui/material";
import { Spacing } from "../../../foundations/spacing.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
const ProductCardContent = styled("div", styledOptions)(({
  isMobile
}) => {
  const gap = isMobile ? Spacing["500"] : Spacing["2000"];
  return {
    gap,
    display: Displaying.flex,
    alignItems: Alignment.center,
    width: "100%"
  };
});
export {
  ProductCardContent
};
//# sourceMappingURL=product-card-content.es.js.map
